import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';

import locales from 'locales';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';


import TagsInput from 'react-tagsinput';
import '../styles/ReactTagsinput.css';
import Translate from "../../../../../components/Translate";

const styles = {
  card: {
    minHeight: '100px',
    borderRadius: '5px',
    margin: '5px',
    padding: '5px',
    background: '#ffffff',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '2px',
  },
  cardNodeName: {
    flexGrow: 1,
    wordBreak: 'break-word',
    marginRight: '7px',
  },
  cardNodeSaveButton: {
    width: '50px',
  },
  cardTagsInput: {

  },
  cardFooter: {
    marginTop: '5px',
  },
  cardNodeTextWrapper: {

  },
  cardNodeText: {
    wordBreak: 'break-word',
  },
  expandButton: {
    cursor: 'pointer',
  },
};


class TagsCardEdit extends React.PureComponent {
  constructor(props) {
    super(props);
    const { node } = this.props;
    this.state = {
      tags: node.tags,
      dirty: false,
      expanded: false,
      editing: false,
    };
  }

  handleTagsChange = (tags) => {
    this.setState({
      tags,
      dirty: true,
    });
  };

  toggleExpandState = () => {
    this.setState((state) => {
      const { expanded } = state;
      return {
        expanded: !expanded,
      };
    });
  };

  editTags = () => {
    const { editTags, node } = this.props;
    const { tags } = this.state;
    this.setState({
      editing: true,
    });
    editTags(node, tags).finally(()=>{
      this.setState({
        editing: false,
      })
    })
  };

  render() {
    const { node, user } = this.props;
    const { tags, dirty, expanded, editing } = this.state;
    const addTagText = `${locales[user.language].addTag}`;

    let FooterContent = (
      <div className="centered-flex-container" style={styles.expandButton}>
        <button type="button" className="no-style-button" onClick={this.toggleExpandState}>
          <ExpandMoreIcon />
        </button>
      </div>
    );
    if (expanded) {
      FooterContent = (
        <div>
          <p style={styles.cardNodeText}>
            {node.message}
          </p>
          <div className="centered-flex-container" style={styles.expandButton}>
            <button type="button" className="no-style-button" onClick={this.toggleExpandState}>
              <ExpandLessIcon />
            </button>
          </div>
        </div>
      );
    }

    return (
      <div style={styles.card}>
        <div style={styles.cardHeader}>
          <p style={styles.cardNodeName}>
            {node.name}
          </p>
          <Button variant="contained" color="primary" size="small" disabled={!dirty ||editing} onClick={this.editTags}>
            <Translate text="save"/>
          </Button>
        </div>
        <div style={styles.cardTagsInput}>
          <TagsInput addOnBlur={true} value={tags} onChange={this.handleTagsChange} inputProps={{placeholder: addTagText}} />
        </div>
        <div style={styles.cardFooter}>
          {FooterContent}
        </div>
      </div>
    );
  }
}

TagsCardEdit.propTypes = {
  node: PropTypes.object.isRequired,
  editTags: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default Radium(TagsCardEdit);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/components/TagsCardEdit.jsx